import useFcmToken from '@hooks/use-fcm-token';
import React, { useEffect } from 'react';
import { getMessaging, onMessage } from 'firebase/messaging';
import firebaseApp from '@utils/firebase';
import { toast, ToastContainer } from 'react-toastify';
import storeFcmTokenApi from '@api/notifications/store-fcm-token';
import Div from '@pezeshk-book/ui-kit/div';
import Text from '@pezeshk-book/ui-kit/text';
import { useRouter } from 'next-nprogress-bar';
import { RootState } from '@store/root-reducer';
import { useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import * as localforage from 'localforage';
import { useParams } from 'next/navigation';
import getParseRoute from '@utils/helpers/parse-route';
import { LocaleTypes } from '@dictionaries-types';

function PushNotificationLayout({ children }: any) {
  const { fcmToken } = useFcmToken();
  const router = useRouter();
  const { isLoggedIn } = useSelector((state: RootState) => state.auth);
  const { lang } = useParams<{lang: LocaleTypes}>();
  useEffect(() => {
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      const messaging = getMessaging(firebaseApp);
      const audio = new Audio('/toast_sound.mp3');
      const unsubscribe = onMessage(messaging, (payload) => {
        audio.play();
        toast(
          <Div className={'flex-col'} onClick={() => handleClickPushNotification(payload?.data?.url)}>
            <Text color={'primary'} align={'right'} type={'bold'} typography={'base'}>{payload?.data?.title}</Text>
            <Text color={'grey.500'} align={'right'} variant={'span'}>{payload?.data?.body}</Text>
          </Div>,
          {
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            autoClose: 5000,
            rtl: true,
          }
        );
      });
      return () => {
        unsubscribe();
      };
    }
  }, []);

  useEffect(() => {
    async function setToken () {
      await storeFcmTokenApi({ cache: 'no-cache', fcmToken: fcmToken });
      await localforage.setItem('fcm_token', fcmToken);
    }
    if (isLoggedIn && fcmToken) {
      setToken();
    }
  }, [fcmToken, isLoggedIn]);

  const handleClickPushNotification = (url: string | undefined) => {
    if (url) {
      router.push(getParseRoute({ pathname: url, locale: lang }));
    }
  };

  return (
    <>
      <ToastContainer/>
      {children}
    </>
  );
}

export default PushNotificationLayout;
